import SaveMainSliderItemTranslate from '../../../../../RunPay/Admin/IServices/Models/MainSliderItem/SaveMainSliderItemTranslate';

export default class SaveMainSliderItemRequest  {
	Id?: number = null;
	Url?: string = '';
	Translations: Array<SaveMainSliderItemTranslate> = null;
	constructor(obj?: Partial<SaveMainSliderItemRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}



// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/IServices/Models/MainSliderItem/SaveMainSliderItemRequest.ts